import React from 'react';

const Loader = () => {
    return (
        <div className="spinner">
            <div className="spinner__result-loading-wrapper">
                <div className="spinner__result-loading-container">
                    <div className="spinner__result-loading-animation" />
                    <p className="spinner__result-loading-message">
                        Retrieving resources
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Loader;
